import React, { useState } from 'react';
import './deleteAccount.scss';
import { PiWarningCircleDuotone } from "react-icons/pi";
import { useNavigate } from 'react-router';

const DeletePgmAccount = () => {

    const [selectedReason, setSelectedReason] = useState('');
    const navigate = useNavigate()
    const questions = [
        {
          id: 1,
          value: "I'm not using it anymore",
          reason: "I'm not using it anymore.",
        },
        {
          id: 2,
          value: "Didn't work as expected",
          reason: "Didn't work as expected",
        },
        {
          id: 3,
          value: "Duplicate account",
          reason: "Duplicate account",
        },
        {
          id: 4,
          value: "I have a privacy concern?",
          reason: "I have a privacy concern",
        },
        {
            id: 5,
            value: "Other",
            reason: "Other",
          },
      ];

    const handleReasonChange = (event) => {
        setSelectedReason(event.target.value);
    };

    const handleDeleteAccount = () => {
        navigate('./verifyOtp')
    };

    return (
        <div className="account-deletion-container">
            <div className='warning-para'>
                <p><span><PiWarningCircleDuotone />Warning:</span>This action cannot be undone!</p>
                <p>You will loose all data related to your account and settings.</p>
            </div>
            <h3 className='select-head'>Please select account deletion reason</h3>
            {questions.map((ques)=>
            <div className='delete-content' key={ques.id}>
                <input
                    className='radio-input'
                    type="radio"
                    name="del_account"
                    value={ques.val}
                    onChange={handleReasonChange} />
                <label className='delete-label' htmlFor="html">{ques.reason}</label><br />
            </div>
            )}
            <button className="del-btn" onClick={handleDeleteAccount} disabled={!selectedReason}>
                Delete Account
            </button>
        </div>
    )
}

export default DeletePgmAccount